import { useParams, useNavigate } from 'react-router-dom'
import axios from 'axios'
import { useAuthHeader } from 'react-auth-kit'
import { useState, useEffect } from 'react'
import Modal from '../../usables/Modal'
import Input from '../../usables/small/Input'
import Button from '../../usables/small/ButtonReal'
import Spinner from '../../usables/small/Spinner'
import ClosingAlert from '../../usables/Alert'
import Card from '../../usables/small/Card'

export default function  Person() {
  const { id } = useParams()
  const auth  = useAuthHeader()
  const navigate = useNavigate()
  const [person, setPerson] = useState({})
  const [formData, setFormData] = useState({name: '', lastname: '', email: '', phone: ''})
  const [dataLoaded, setDataLoaded] = useState({done: false, sucssess: false, items: 0})

  const config = {
    headers: {
      Authorization: auth()
    }
  }

  
  const deletePerson = () => {
    axios.delete(process.env.REACT_APP_API + `/people/${id}`, config)
      .then((res)=>{
        if(res.status === 200){
          navigate('/people')
        }
      })
  }

  const updatePerson = () => {
    axios.patch(process.env.REACT_APP_API + `/people/${id}`, formData, config)
      .then((res)=>{
        if(res.status === 200){
          setPerson(res.data.person)
        }
      })
    }

  useEffect(() => {
    axios.get(process.env.REACT_APP_API + `/people/${id}`, config)
    .then(res => {
      if(res.status === 200){
        setPerson(res.data.person)
        setFormData({name: res.data.person.name, lastname: res.data.person.lastname, email: res.data.person.email, phone: (res.data.person.phone === null) ? '' : res.data.person.phone})
        setDataLoaded({done: true, sucssess: true, items: 1})
      }
    })
    .catch(err => {
      //console.log(err.response.data)
      setPerson(err.response.data)
      setDataLoaded({done: true, sucssess: false, items: 0})
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
    {dataLoaded.sucssess ? <h2>{person.name + ' ' + person.lastname}</h2> : null}
      {!dataLoaded.done
      ? <Spinner />
      : dataLoaded.sucssess
        ?dataLoaded.items
          ? <>
          {JSON.stringify(person)}
          <div className="p-10 grid grid-cols-1 sm:grid-cols-1 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-3 gap-5">
              <Card title='Pagrindinė informacija'>
                <ul className='divide-y divide-gray-200'>
                  <li className="py-3 sm:py-4">
                    <div className="flex items-center space-x-4">
                      <div className="flex-1 min-w-0">
                        <p className="text-sm font-medium text-gray-900 truncate ">
                          Vardas
                        </p>
                      </div>
                      <div className="inline-flex items-center text-base font-semibold text-gray-900 ">
                        {person.person.name}
                      </div>
                    </div>
                  </li>
                  <li className="py-3 sm:py-4">
                    <div className="flex items-center space-x-4">
                      <div className="flex-1 min-w-0">
                        <p className="text-sm font-medium text-gray-900 truncate ">
                          Pavardė
                        </p>
                      </div>
                      <div className="inline-flex items-center text-base font-semibold text-gray-900 ">
                        {person.person.lastname}
                      </div>
                    </div>
                  </li>
                  <li className="py-3 sm:py-4">
                    <div className="flex items-center space-x-4">
                      <div className="flex-1 min-w-0">
                        <p className="text-sm font-medium text-gray-900 truncate ">
                          El. paštas
                        </p>
                      </div>
                      <div className="inline-flex items-center text-base font-semibold text-gray-900 ">
                        {(person.person.email !== null) ? person.person.email : 'nėra'}
                      </div>
                    </div>
                  </li>
                  <li className="py-3 sm:py-4">
                    <div className="flex items-center space-x-4">
                      <div className="flex-1 min-w-0">
                        <p className="text-sm font-medium text-gray-900 truncate ">
                          Telefonas
                        </p>
                      </div>
                      <div className="inline-flex items-center text-base font-semibold text-gray-900 ">
                        {(person.person.phone !== null) ? person.person.phone : 'nėra'}
                      </div>
                    </div>
                  </li>
                </ul>
                {/* modal */}
              </Card>
            </div>
          <Modal btnText='Redaguoti' title='Redaguoti' saveText='Išsaugoti' submitFunction={() => updatePerson()}>
          <div className='pt-5'>
            <Input
              label='Vardas'
              name='name'
              type='text'
              value={formData.name}
              onChange={(e)=>setFormData({...formData, name: e.target.value})}
              />
            <Input
              label='Pavardė'
              name='lastname'
              type='text'
              value={formData.lastname}
              onChange={(e)=>setFormData({...formData, lastname: e.target.value})}
              />
            <Input
              label='El. paštas'
              name='email'
              type='email'
              value={formData.email}
              onChange={(e)=>setFormData({...formData, email: e.target.value})}
              />
            <Input
              label='Telefonas'
              name='phone'
              type='tel'
              value={formData.phone}
              onChange={(e)=>setFormData({...formData, phone: e.target.value})}
              />
            </div>
          </Modal>
          <Button text='Naikinti' danger onClick={() => deletePerson()}/>
          </>
          : <ClosingAlert type='warning' message='Nerastas jokia informacija' />
        : <ClosingAlert type='error' message='Nerastas asmuo' />
      }

    
    </>
  )
}